var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    stroke: "#CBCACA",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83 10.547c-.522.837-1.94 1.19-2.594.61-.264-.235-.445-.727-.424-1.088.044-.77.235-1.534.382-2.297.212-1.093.218-1.092-.837-1.622.27-.076.434-.156.601-.162.5-.018 1-.012 1.5-.006.667.009.799.174.676.85-.164.903-.336 1.804-.502 2.706-.025.137-.053.275-.06.414-.035.72.226.915.895.682.102-.035.21-.051.363-.087zM8.404 4.342c-.012.561-.45.966-1.02.941-.569-.025-.938-.438-.922-1.032.014-.553.412-.931.964-.916.54.015.99.476.978 1.007z",
    fill: "#CBCACA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAbout);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconAbout.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };